export default {
    setScreenSize: (state) => {
        state.window_size.width = window.innerWidth;
        state.window_size.height = window.innerHeight;
    },
    setLocalStorage: (state, data) => {
        Object.keys(data).forEach(key => {
            localStorage[key] = data[key];
        });
    },
	setCompany: (state, company) => {
		state.company = company;
        localStorage.setItem('company', JSON.stringify(company));
	},
    setCountries: (state, countries) => {
        state.countries = countries
    },
    setCities: (state, cities) => {
        state.cities = cities
    }
}
